export const heater = 'heater';

const branchSafety = 'branch-safety';
const stepGoalTemp = 'goal-temp';
const stepFlowRate = 'flow-rate';

const stepResult = 'result';
const is3PhasePower = 'is-3-phase-power';
const stepVoltage = 'voltage';

export default [
  {
    id: `${branchSafety}_${is3PhasePower}`,
    step: '3-phase power',
    component: 'Selector',
    title: 'Is 3-phase power going to be used?',
    options: [
      {
        title: 'Yes',
        params: { phase: 3 },
        value: '1',
        nextId: `${branchSafety}_3phase_${stepVoltage}`,
        typeYes: true,
      },
      {
        title: 'No',
        value: '0',
        params: { phase: 1 },
        nextId: `${branchSafety}_1phase_${stepVoltage}`,
        typeNo: true,
      },
    ],
    tip: '<b>Note</b>: For higher GPM flow rates (+4 GPM), you will likely need 3-Phase power to facilitate the higher kW necessary to achieve higher temperatures!!',
  },
  {
    id: `${branchSafety}_1phase_${stepVoltage}`,
    step: 'Voltage',
    component: 'Selector',
    title: 'What is your choice of Single-Phase voltage for your heater?',
    options: [
      { title: '120 V', value: 120, nextId: `${branchSafety}_1phase_${stepFlowRate}` },
      { title: '208 V', value: 208, nextId: `${branchSafety}_1phase_${stepFlowRate}` },
      { title: '240 V', value: 240, nextId: `${branchSafety}_1phase_${stepFlowRate}` },
      { title: '277 V', value: 277, nextId: `${branchSafety}_1phase_${stepFlowRate}` },
    ],
    paramName: 'volts',
  },
  {
    id: `${branchSafety}_3phase_${stepVoltage}`,
    step: 'Voltage',
    component: 'Selector',
    title: 'What is your choice of 3-Phase voltage for your heater?',
    options: [
      { title: '208 V', params: { volts: 208, 'product-family': ['bcbcf016-b763-4453-949e-0ac175ea7a1b'] }, nextId: `${branchSafety}_3phase_${stepFlowRate}` },
      { title: '480 V', params: { volts: 480, 'product-family': ['bcbcf016-b763-4453-949e-0ac175ea7a1b'] }, nextId: `${branchSafety}_3phase_${stepFlowRate}` },
      { title: '600 V', params: { volts: 600, 'product-family': ['bcbcf016-b763-4453-949e-0ac175ea7a1b'] }, nextId: `${branchSafety}_3phase_${stepFlowRate}` },
    ],
  },
  {
    id: `${branchSafety}_1phase_${stepFlowRate}`,
    step: 'Flow Rate',
    component: 'FlowRateWithSelect',
    tip: '<b>Note</b>: When sizing for a point of use unit, the unit should be as close as possible to the fixtures it services, otherwise it will adversely affect the time to temperature delivery!! It would be highly recommended to get separate sizing for a separate unit if other fixture locations are further away (beyond 15’ – 20’). Continue below to select the local fixtures.',
    paramName: 'max-flow',
    nextId: `${branchSafety}_1phase_${stepGoalTemp}`,
    title: 'Which fixture(s) would the unit be servicing?',
    text: 'IMPORTANT: The fixtures selected here should represent the maximum amount of water that would be running simultaneously. These fixtures are close to the unit and do not represent the TOTAL amount of fixtures needed for the whole system unless applicable.',
    hint: 'You can manually overwrite your simultaneous flow rate to the right if your fixture flow rates differ from the selections above',
    fixtures: [
      {
        title: 'Low Flow Eyewash',
        flowRate: '~2 GPM',
        flowRateValue: 2,
        img: `${process.env.VUE_APP_PATH}/img/LFE.jpg`,
        quantity: 1,
      },
      {
        title: 'Standard Eyewash / Face Wash',
        flowRate: '~4 GPM',
        flowRateValue: 4,
        img: `${process.env.VUE_APP_PATH}/img/SEFW.jpg`,
        quantity: 0,
      },
    ],
  },
  {
    id: `${branchSafety}_1phase_${stepGoalTemp}`,
    step: 'Goal Temperature',
    component: 'GoalTemperature',
    paramName: 'temp-out',
    title: 'Goal Temperature (°F)',
    text: 'Eemax issues Safety type water heaters set at 90°F, not to exceed, which can be field-adjusted down to just below 75°F.',
    hint: 'If you have a different goal temperature, enter that above, otherwise leave at the default entry of 90(°F):',
    defaultValue: 90,
    locked: false,
    nextId: `${branchSafety}_1phase_${stepResult}`,
  },
  {
    id: `${branchSafety}_1phase_${stepResult}`,
    step: 'Result',
    component: 'Result',
    type: heater,
  },
  {
    id: `${branchSafety}_3phase_${stepFlowRate}`,
    step: 'Flow Rate',
    component: 'FlowRateWithSelect',
    tip: '<b>Note</b>: NOTE: When sizing for a point of use unit, the unit should be as close as possible to the fixtures it services, otherwise it will adversely affect the time to temperature delivery!! It would be highly recommended to get separate sizing for a separate unit if other fixture locations are further away (beyond 15’ – 20’). Continue below to select the local fixtures.\n',
    paramName: 'max-flow',
    nextId: `${branchSafety}_3phase_${stepGoalTemp}`,
    title: 'Which fixture(s) would the unit be servicing?',
    text: 'IMPORTANT: The fixtures selected here should represent the maximum amount of water that would be running simultaneously. These fixtures are close to the unit and do not represent the TOTAL amount of fixtures needed for the whole system unless applicable.',
    hint: 'You can manually overwrite your simultaneous flow rate to the right if your fixture flow rates differ from the selections above',
    fixtures: [
      {
        title: 'Low Flow Eyewash',
        flowRate: '~2 GPM',
        flowRateValue: 2,
        img: `${process.env.VUE_APP_PATH}/img/LFE.jpg`,
        quantity: 1,
      },
      {
        title: 'Standard Eyewash / Face Wash',
        flowRate: '~4 GPM',
        flowRateValue: 4,
        img: `${process.env.VUE_APP_PATH}/img/SEFW.jpg`,
        quantity: 1,
      },
      {
        title: 'Eye/Face Wash & Drench Combination',
        flowRate: '~20 GPM',
        flowRateValue: 20,
        img: `${process.env.VUE_APP_PATH}/img/EWDC.jpg`,
        quantity: 0,
      },
    ],
  },
  {
    id: `${branchSafety}_3phase_${stepGoalTemp}`,
    step: 'Goal Temperature',
    component: 'GoalTemperature',
    paramName: 'temp-out',
    title: 'Goal Temperature (°F)',
    text: 'Eemax issues Safety type water heaters set at 90°F, not to exceed, which can be field-adjusted down to just below 75°F.',
    hint: 'If you have a different goal temperature, enter that above, otherwise leave at the default entry of 90(°F):',
    defaultValue: 90,
    locked: false,
    nextId: `${branchSafety}_3phase_${stepResult}`,
  },
  {
    id: `${branchSafety}_3phase_${stepResult}`,
    step: 'Result',
    component: 'Result',
    type: heater,
  },
];
